import {CanActivate} from '@angular/router';
import {Injectable} from '@angular/core';

import {Observable, of} from 'rxjs';
import {catchError, filter, switchMap, take, tap} from 'rxjs/operators';
import {select, Store} from '@ngrx/store';

import {ApplicationState} from '../../application-state/store';
import {CurrenciesActions} from '../store';
import {CurrenciesSelectors} from '../store/selectors';

@Injectable()
export class CurrenciesLoadedGuard implements CanActivate {

  constructor(private store: Store<ApplicationState>) {
  }

  canActivate(): Observable<boolean> {
    return this.readCurrenciesDone().pipe(
      switchMap(() => of(true)),
      catchError(() => of(false))
    );
  }

  readCurrenciesDone(): Observable<boolean> {
    return this.store.pipe(
      select(CurrenciesSelectors.isLoaded),
      tap((loaded: boolean) => {
        if (!loaded) {
          this.store.dispatch(CurrenciesActions.ReadCurrencies());
        }
      }),
      filter(loaded => loaded),
      take(1)
    );
  }
}
